module.exports = __webpack_public_path__ + "img/green_cabinet_alerts.3afa0ae3.svg";